<template>
  <div class="inline-flex flex-col">
    <label v-if="label" :for="id" class="mb-1.5 flex-1 text-lg font-medium text-primary-dark dark:text-primary-light">
      {{ label }}
    </label>
    <div
      class="flex w-full items-center rounded-md border px-4 py-2.5 ring-offset-0 focus-within:border-indigo-600 focus-within:ring-1 focus-within:ring-indigo-600"
      :class="error
        ? 'border-red-300 bg-ternary-light text-red-400 dark:border-red-600 dark:bg-ternary-dark dark:text-secondary-light'
        : 'border-gray-300 bg-ternary-light text-primary-dark dark:border-gray-600 dark:bg-ternary-dark dark:text-secondary-light'"
    >
      <textarea
        v-if="type === 'textarea'"
        :id="id"
        :required="required"
        :rows="rows"
        :value="modelValue"
        :placeholder="placeholder"
        class="w-full appearance-none bg-transparent focus:outline-none"
        @input="emit('update:modelValue', ($event.target as HTMLTextAreaElement).value)"
      />
      <input
        v-else
        :id="id"
        :required="required"
        :type="type"
        :value="modelValue"
        :placeholder="placeholder"
        class="h-5 w-full appearance-none bg-transparent focus:outline-none"
        @input="emit('update:modelValue', ($event.target as HTMLInputElement).value)"
      >
    </div>
    <div v-if="error" class="mt-3 text-sm text-red-500">
      {{ error }}
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  modelValue?: string
  label?: string
  error?: string
  type?: string
  placeholder?: string
  rows?: number
  required?: boolean
}>(), {
  modelValue: '',
  label: undefined,
  error: undefined,
  type: 'text',
  placeholder: undefined,
  rows: 3,
  required: false,
})

const emit = defineEmits<{ 'update:modelValue': [value: string] }>()
const id = useId()
</script>
